var exports = {
  "kL": "xcc377c0b--fa37a0--container",
  "vu": "xcc377c0b--fa37a0--active",
  "DD": "xcc377c0b--fa37a0--title",
  "WD": "xcc377c0b--fa37a0--labels",
};

module.exports = exports;
